import styled, { css } from "styled-components";
import media from "styled-media-query";

export const Wrapper = styled.div`
  padding: 80px 20px 40px;
  width: 100%;

  ${({ hasBreadcrumb }) =>
    hasBreadcrumb &&
    css`
      grid-template-rows: min-content auto;
    `}

  ${media.greaterThan("medium")`
    margin: 0 auto;
    max-width: 1300px;
    padding: 40px 64px;
  `}
`;

export const BroadCramb = styled.div``;
